import React from "react";
import {ListItemIcon, makeStyles, Menu, MenuItem} from "@material-ui/core";
import {Edit, HighlightOff, Undo} from "@material-ui/icons";
import FileCopyIcon from "@material-ui/icons/FileCopy";

const useStyles = makeStyles({
    contextPaper: {
        paddingTop: 0,
        paddingBottom: 0
    },
    menuItemRoot: {
        color: '#676767',
        '&:hover': {
            color: '#000000'
        }
    },
    listIconRoot: {
        minWidth: 30
    }
});

const ContextMenu = ({anchorEl, onClose, addBefore, addAfter, edit, remove, index, itemsCount, duplicateItem}) => {
    const classes = useStyles();
    return (
        <Menu
            classes={{list: classes.contextPaper}}
            open={anchorEl.mouseY !== null}
            anchorReference={"anchorPosition"}
            anchorPosition={
                anchorEl.mouseY !== null && anchorEl.mouseX !== null
                    ? {top: anchorEl.mouseY, left: anchorEl.mouseX}
                    : undefined
            }
            onClose={onClose}
        >
            <MenuItem
                dense
                classes={{root: classes.menuItemRoot}}
                onClick={(e) => {
                    e.stopPropagation();
                    edit();
                    onClose();
                }}
            >
                <ListItemIcon classes={{root: classes.listIconRoot}}>
                    <Edit fontSize="small"/>
                </ListItemIcon>
                Edit
            </MenuItem>
            <MenuItem
                dense
                classes={{root: classes.menuItemRoot}}
                onClick={(e) => {
                    e.stopPropagation();
                    addBefore();
                    onClose();
                }}
            >
                <ListItemIcon classes={{root: classes.listIconRoot}}>
                    <Undo fontSize="small"/>
                </ListItemIcon>
                Add Before
            </MenuItem>
            <MenuItem
                dense
                classes={{root: classes.menuItemRoot}}
                onClick={(e) => {
                    e.stopPropagation();
                    addAfter();
                    // duplicateItem(`${parentPath}.children`, item, index);
                    onClose();
                }}
            >
                <ListItemIcon classes={{root: classes.listIconRoot}}>
                    <Undo fontSize="small" style={{transform: 'rotate(180deg)'}}/>
                </ListItemIcon>
                Add After
            </MenuItem>
            <MenuItem
                dense
                classes={{root: classes.menuItemRoot}}
                onClick={(e) => {
                    e.stopPropagation();
                    //addAfter();
                    duplicateItem();
                    onClose();
                }}
            >
                <ListItemIcon classes={{root: classes.listIconRoot}}>
                    <FileCopyIcon fontSize="small"/>
                </ListItemIcon>
                Duplicate
            </MenuItem>
            <MenuItem
                dense
                disabled={itemsCount === 1 && index === itemsCount - 1}
                classes={{root: classes.menuItemRoot}}
                onClick={(e) => {
                    e.stopPropagation();
                    remove();
                    onClose();
                }}
            >
                <ListItemIcon classes={{root: classes.listIconRoot}}>
                    <HighlightOff fontSize="small"/>
                </ListItemIcon>
                Remove
            </MenuItem>
        </Menu>
    )
};
export default ContextMenu;